import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import {
  AppBar,
  DriverForm,
  ReferenceForm,
  CheckIn,
  ShippingInfo,
  EdocsHomePage,
  Home,
  LoadingSpinner,
  SessionTimeOut,
  TimeoutModal,
  CheckOut,
  RFID,
  VisitSummary,
  GateLinkUSDOT,
  GateLinkTrailer,
  GateLinkTractor,
  GateLinkActivate,
  AssetSummary,
  SuccessAssets,
  VisitPurpose,
  PurposeRequest,
  KioskUSDOT,
  KioskTrailer,
  KioskTractor,
  KioskTrailerType,
  KioskCheckIn,
  SuccessKioskCheckIn,
  KioskAssetSummary,
  GateLinkCarrierSearch,
  EventTracking,
  BreakTracking,
  GatePass,
  DispatchDetails
} from "./components"
import { info, Warning } from "../src/images"
import IdleTimer from "react-idle-timer"
import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { RootState } from "store/store"
import { ToastContainer } from "react-toastify"
import i18n from "../src/locale/config"
import { I18nextProvider } from "react-i18next"
import "./App.css"
import { buildEnvironment } from "config/build-environment"

let idleTimer: any = null
const App = () => {
  let logoutTimer: any = null
  const buildEnv = buildEnvironment === "qat" ? "dev" : buildEnvironment
  const urlBuildAWSEnv = buildEnvironment === "prod" ? "" : `-${buildEnvironment}`
  const urlBuildAzureEnv = buildEnv === "prod" ? "" : `-${buildEnv}`
  const [showModal, setShowModal] = useState(false)
  const [seconds, setSeconds] = useState(10)
  const [isActive, setIsActive] = useState(false)
  const driverObj = useSelector(
    (state: RootState) => state.driverReducer.driver
  )
  const rootPath = useSelector((state: RootState) => state.locationReducer.path)
  const facilityCode = useSelector(
    (state: RootState) => state.locationReducer.facilityCode
  )
  const onIdle = () => {
    togglePopup()
    setIsActive(true)
  }
  const togglePopup = () => {
    setShowModal(!showModal)
  }
  const handleStayLoggedIn = () => {
    clearTimeout(logoutTimer)
    if (logoutTimer) {
      logoutTimer = null
    }
    idleTimer.reset()
    setSeconds(10)
    setIsActive(false)
    togglePopup()
  }
  const handleLogout = () => {
    setShowModal(true)
    togglePopup()
    window.location.pathname = "/sessiontimeout"
  }
  const Logout = () => {
    togglePopup()
    window.location.pathname = facilityCode
  }

  useEffect(() => {
    let interval: any = null
    if (isActive) {
      interval = setInterval(() => {
        setSeconds(seconds => seconds - 1)
      }, 1000)
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval)
    }
    if (seconds === 0) {
      handleLogout()
    }
    return () => clearInterval(interval)
  }, [isActive, seconds])

  return (
    <>
      <LoadingSpinner />
      <ToastContainer
        autoClose={3000}
        position="top-center"
        hideProgressBar={true}
        closeOnClick
        draggable={false}
      />
      <I18nextProvider i18n={i18n}>
        <Router>
          <AppBar />
          <Switch>
            <Route exact path="/check-in" component={() => <CheckIn />} />
            <Route
              exact
              path="/reference-details"
              component={() => <ReferenceForm />}
            />
            <Route exact path="/edocs" component={() => <EdocsHomePage />} />
            <Route exact path="/support" component={() => <ShippingInfo />} />
            <Route exact path="/checkout" component={() => <CheckOut />} />
            <Route
              exact
              path="/kiosk-carrier-info"
              component={() => <KioskUSDOT />}
            />
            <Route
              exact
              path="/kiosk-trailer-info"
              component={() => <KioskTrailer />}
            />
            <Route
              exact
              path="/kiosk-trailer-type"
              component={() => <KioskTrailerType />}
            />
            <Route
              exact
              path="/kiosk-tractor-info"
              component={() => <KioskTractor />}
            />

            <Route
              exact
              path="/c-reference"
              component={() => <PurposeRequest />}
            />
            <Route
              exact
              path="/carrier-info"
              component={() => <GateLinkUSDOT />}
            />
            <Route
              exact
              path="/carrier-search"
              component={() => <GateLinkCarrierSearch />}
            />
            <Route
              exact
              path="/dispatch-details"
              component={() => <DispatchDetails />}
            />
            <Route
              exact
              path="/trailer-info"
              component={() => <GateLinkTrailer />}
            />
            <Route exact path="/RFID-code" component={() => <RFID />} />
            <Route
              exact
              path="/event-tracking"
              component={() => <EventTracking />}
            />
            <Route
              exact
              path="/activate-network-tracking"
              component={() => <GateLinkActivate />}
            />
            <Route
              exact
              path="/break-tracking"
              component={() => <BreakTracking />}
            />
            <Route
              exact
              path="/tractor-info"
              component={() => <GateLinkTractor />}
            />
            <Route
              exact
              path="/asset-summary"
              component={() => <AssetSummary />}
            />
            <Route exact path="/gate-pass" component={() => <GatePass />} />
            <Route
              exact
              path="/visitsummary"
              component={() => <VisitSummary />}
            />
            <Route
              exact
              path="/success-asset"
              component={() => <SuccessAssets />}
            />
            <Route
              exact
              path="/sessiontimeout"
              component={() => <SessionTimeOut />}
            />
            <Route
              exact
              path="/success-kiosk"
              component={() => <SuccessKioskCheckIn />}
            />
            <Route exact path="/:siteCode" component={() => <DriverForm />} />
            <Route exact path="/" component={() => <Home />} />
          </Switch>
        </Router>
      </I18nextProvider>
      {window.location.href ===
        `https://fasttrack${urlBuildAWSEnv}.fourkites.com/${facilityCode}` &&
        (window.location.href = `https://portal${urlBuildAzureEnv}.fourkites.com/fasttrack/${facilityCode}`)}
      {window.location.pathname === "/sessiontimeout" ||
        (rootPath !== "driverForm" &&
          rootPath !== "activate-network-tracking" && (
            <IdleTimer
              ref={(ref: any) => {
                idleTimer = ref
              }}
              element={document}
              stopOnIdle={true}
              onIdle={onIdle}
              timeout={50000}
            />
          ))}
      <TimeoutModal
        showModal={showModal}
        handleStayLoggedIn={handleStayLoggedIn}
        Logout={Logout}
        driverObj={driverObj.name}
        info={info}
        seconds={seconds}
        Warning={Warning}
      />
    </>
  )
}
export default App
